@if (isLoading) {
  <app-loading-indicator
    [isLoading]="isLoading"
    class="load-indicator"
    id="zitiEndpointsPage"
  ></app-loading-indicator>
}

<div class="area data-table" id="ItemsArea">
  @if (items.length >= 0 || filterHasChanged) {
    <app-data-table
      (gridReady)="onGridReady($event)"
      [columnDefinitions]="columnDefs"
      [columnFilters]="columnFilters"
      [downloadAllEvents]="downloadAllEvents.bind(this)"
      [downloadFilteredEvents]="downloadFilteredEvents.bind(this)"
      [filterChanged]="filterChanged.bind(this)"
      [isTimeSearchAvailable]="true"
      [isNotDialLogs]="true"
      [isUTC]="isUTC"
      [minDate]="minDate"
      [newEndTime]="newEndTime"
      [newStartTime]="newStartTime"
      [rowData]="items"
      [hideSelectColumn]="true"
      [tableId]="'management-events'"
      pagination="true"
      paginationPageSize="30"
      >
    </app-data-table>
  }
</div>
